<script setup>
import {computed} from 'vue'
import moment from 'moment'

const props = defineProps({
    oldValue: String,
    newValue: String,
    dateFormat: String
})

const oldDate = computed(() => {
    return props.oldValue ? moment(props.oldValue).format('DD MMM YYYY, HH:mm') : '<i>empty</i>'
})

const newDate = computed(() => {
    return props.newValue ? moment(props.newValue).format('DD MMM YYYY, HH:mm') : '<i>unset</i>'
})
</script>

<template>
    <div class="d-flex align-items-center">
        <small v-if="oldDate" class="border rounded py-1 px-2" v-html="oldDate"></small>
        <i v-else class="small">empty</i>

        <i class="mx-2 bi-chevron-right"/>

        <small v-if="newDate" class="border rounded py-1 px-2" v-html="newDate"></small>
        <i v-else class="small">empty</i>
    </div>
</template>